/* eslint-disable */
export default {
    LOG_OUT: 'Odhlásiť sa',
    LOGIN: 'Prihlásenie',
    GET_A_MAP_EXPERT: 'Získajte mapového experta',
    MY_ACCOUNT: 'Môj účet',
    MY_ACCOUNT_DESC: 'Môžete zmeniť svoje nastavenia',
    SUBSCRIPTION: 'Predplatné',
    PASSWORD: 'Heslo',
    LANGUAGE: 'Jazyk',
    AVAILABLE_LANGUAGES: 'Dostupné jazyky',
    YOU_HAVE_NO_PASSWORD: 'Nemáte heslo',
    YOU_HAVE_NAME: 'Používate {0} verziu Mapheimu',
    SUBSCRIBE_ACTION: 'Predplatiť',
    MANAGE_SUBSCRIPTION: 'Spravovať predplatné',
    CANCELLED_SUBSCRIPTION: 'Vaše predplatné bolo zrušené a bude deaktivované na konci vašeho účtovného obdobia',
    RENEW_SUBSCRIPTION: 'Obnoviť predplatné',
    RESUBSCRIBE: 'Znovu predplatiť',
    VIEW_PAST_INVOICES: 'Zobraziť minulé faktúry',
    SUBSCRIBE_NOT_PAID: 'Vaše predplatné sa nepodarilo zaplatiť. Skontrolujte svoje platobné údaje a opakujte platbu',
    REVIEW_PAYMENT: 'Skontrolovať platbu',
    YOUR_MAPS: 'Vaše mapy',
    EDIT_CONTENT: 'Upraviť obsah',
    ADVANCED_EDITOR: 'Pokročilý editor',
    CUSTOM_URL: 'Vlastná URL',
    UNNAMED_MAP: 'Nepomenovaná mapa',
    EDIT: 'Upraviť',
    WELCOME: 'Vitajte',
    WELCOME_DESC: 'Užite si prácu s vašimi mapami!',
    DO_YOU_WANT_NEW_MAP: 'Chcete novú mapu?',
    UPGRADE_ACTION: 'Vylepšiť',
    CREATE_ACTION: 'Vytvoriť',
    UPGRADE_EXPERIENCE: 'Vylepšite si svoj zážitok',
    UPGRADE_EXPERIENCE_DESC: 'Získajte viac zo svojich máp',
    NEED_HELP: 'Potrebujete pomoc?',
    LET_US_KNOW: 'Dajte nám vedieť',
    CONTACT_ACTION: 'Kontakt',
    MO: 'me.',
    SUB1: 'Tvorca',
    SUB1_DESC: 'Pre nadšených tvorcov',
    VIEWS_PER_MONTH: '{0} zobrazení / mesiac',
    MARKERS_PER_MAP: '{0} značiek / mapa',
    X_MAPS: '{0} máp',
    DEDICATED_SUPPORT: 'Vyhradená podpora',
    MANAGE_ACTION: 'Spravovať',
    DOWNGRADE_ACTION: 'Zhoršiť',
    SUB2: 'Pro',
    SUB2_DESC: 'Pre profesionálne použitie',
    UNLIMITED_MARKERS: 'Neobmedzený počet značiek',
    UNLIMITED_MAPS: 'Neobmedzený počet máp',
    SUB3: 'Vlastný',
    SUB3_DESC: 'Pre akékoľvek mapové potreby',
    SUB3_TEXT1: 'Potrebujete viac zobrazení, špeciálne funkcie alebo pomoc s vytvorením mapy?',
    SUB3_TEXT2: 'Vytvorili sme mapy pre zábavné parky, konferencie, cestovný ruch, festivaly a mnoho ďalších odvetví. Dajte nám vedieť',
    CONTACT_US: 'Kontaktujte nás',
    PREVIEW_MAP: 'Náhľad mapy',
    SHARE_ACTION: 'Zdieľať',
    GET_ACCESS: 'Získať prístup',
    LOGIN_TO_BECOME: 'Prihláste sa, aby ste sa stali skutočným tvorcom máp alebo',
    CREATE_A_MAP: 'vytvoriť mapu',
    AS_A_GUEST: 'ako hosť',
    REGISTER_CREATOR: 'Zaregistrujte sa, aby ste sa stali skutočným tvorcom máp',
    REGISTRATION: 'Registrácia',
    USING_SOCIALS: 'Použitie sociálnych sietí',
    USING_MAIL: 'Použitie e-mailu',
    EMAIL_OR_USER: 'Email alebo používateľské meno',
    FORGOT_PASSWORD: 'Zabudnuté heslo',
    LOGIN_ACTION: 'Prihlásiť sa',
    ERROR_USER_NOT_FOUND: 'Používateľ nebol nájdený',
    ERROR_WRONG_PASSWORD: 'Zlé heslo',
    ERROR_USER_BANNED: 'Používateľ je zablokovaný',
    ERROR_EMAIL_NOT_VERIFIED: 'Email nie je overený',
    ERROR_LOGIN: 'Chyba pri prihlasovaní',
    VERIFICATION_SENT1: 'Ověrovací odkaz bol odoslaný na vašu e-mailovú adresu',
    VERIFICATION_SENT2: 'Skontrolujte svoju doručenú poštu a priečinok spam a kliknite na odkaz, aby ste dokončili registráciu',
    EMAIL: 'Email',
    CONFIRM_PASSWORD: 'Potvrďte heslo',
    INVALID_EMAIL: 'Email nie je platný',
    PASSWORD_NOT_STRONG: 'Nové heslo nie je dostatočne silné alebo heslá nie sú rovnaké. Musí mať aspoň 6 znakov',
    EMAIL_USED: 'Používateľ s týmto e-mailom je už registrovaný',
    ERROR_REGISTRATION: 'Chyba pri registrácii nového používateľa',
    MAP_NOT_ACCESSIBLE: 'K tejto mape nie je možné pristupovať',
    MAP_NOT_ACCESSIBLE_DESC: 'Kontaktujte prosím majiteľa mapy, aby bola mapa znovu dostupná',
    RETRIEVE_ACCESS: 'Získať prístup',
    RETRIEVE_ACCESS_DESC: 'Zmeňte heslo, aby ste sa stali skutočným tvorcom máp',
    SEND_RESET_LINK_ACTION: 'Odoslať odkaz',
    RESET_LINK_SENT: 'Email s odkazom na obnovenie bol odoslaný na vašu e-mailovú adresu. Skontrolujte svoju doručenú poštu a priečinok spam',
    ERROR_SENT_LINK: 'Chyba pri odosielaní odkazu na obnovenie',
    EMAIL_VERIFIED: 'E-mail overený',
    EMAIL_VERIFIED_DESC: 'Prihláste sa a začnite vytvárať',
    RESET_PASSWORD: 'Zmeniť heslo',
    RESET_PASSWORD_DESC: 'Zmeňte heslo, aby ste sa stali skutočným tvorcom máp',
    INVALID_LINK: 'Neplatný odkaz',
    ERROR_RESET_CODE: 'Kód na obnovenie vypršal. Pošlite prosím nový kód na obnovenie',
    ERROR_RESETTING: 'Chyba pri nastavení nového hesla',
    NEW_PASSWORD: 'Nové heslo',
    SET_NEW_PASSWORD: 'Nastaviť nové heslo',
    HEADER: 'Hlavička',
    NO_HEADER: 'Bez hlavičky',
    TITLE: 'Názov',
    DESCRIPTION: 'Popis',
    SELECT_ACTION: 'Vybrať',
    CONTENT: 'Obsah',
    CONTENT_DESC: 'Môžete tiež pridať rôzne karty obsahu do svojho značenia (doporučené)',
    POST_URL: 'URL príspevku',
    POST_ID: 'ID príspevku',
    VIDEO_URL: 'URL videa',
    ADD_FIRST_CARD: 'Pridajte prvú kartu',
    LINK: 'Odkaz',
    CONFIRM_DELETE_LINK: 'Chcete tento odkaz zmazať?',
    ADD_LINK: 'Pridať odkaz',
    ADD_ANOTHER_LINK: 'Pridať ďalší odkaz',
    NAME: 'Názov',
    TYPE: 'Typ',
    GUIDE: 'Sprievodca',
    OLD_GUIDE: 'Starý sprievodca',
    SHARE_THE_LINK: 'Zdieľať odkaz',
    COPY_MAP_ID: 'ID mapy pre Wordpress Plugin',
    COPY_MAP_ID_ACTION: 'Kopírovať ID mapy',
    COPY_MAP_ID_CLIPBOARD: 'ID mapy bolo skopírované do schránky',
    LINK_COPIED_CLIPBOARD: 'Odkaz bol skopírovaný do schránky',
    GUIDE_COLORS_ACCENT1: 'Hlavná farba',
    CUSTOM: 'Vlastný',
    SAVE: 'Uložiť',
    ALL_SAVED: 'Všetko uložené',
    COPY_URL_ACTION: 'Kopírovať URL',
    GENERATE_QR_CODE: 'Generovať QR kód',
    DOWNLOAD_QR_ACTION: 'Stiahnuť QR',
    EMBED_ON_YOUR_SITE: 'Vložiť na váš web',
    COPY_HTML_ACTION: 'Kopírovať HTML',
    HTML_COPIED_CLIPBOARD: 'HTML bol skopírovaný do schránky',
    HISTORY: 'História',
    MARKERS: 'Značky',
    LOCATION: 'Poloha',
    LOADING: 'Načítavanie',
    NOTHING_FOUND: 'Nič sa nenašlo',
    PLEASE_WRITE_CHARACTERS: 'Prosím napíšte aspoň 3 znaky',
    MOUSE: 'Myš',
    PIN: 'Značka',
    IMAGE: 'Obrázok',
    TEXT: 'Text',
    DRAW: 'Kresba',
    DIRECTION: 'Trasa',
    LINE: 'Čiara',
    POLYGON: 'Polygon',
    WALL_LINE: '3D Stena',
    WALL_FILL: '3D Stena (Vyplnená)',
    REACT: 'React',
    CHATGPT: 'ChatGPT',
    UPLOAD_ACTION: 'Nahrať',
    PROPERTIES: 'Vlastnosti',
    INTERACTIVITY: 'Interaktivita',
    MAP_SETTINGS: 'Nastavenia mapy',
    PRIVACY: 'Súkromie',
    PRIVACY_DESC: 'Súkromné mapy nie je možné zdieľať s nikým',
    GPS_POSITION: 'GPS poloha',
    ENABLED: 'Aktivované',
    DISABLED: 'Deaktivované',
    BUBBLE_DESC: 'Kliknutím na interaktívnu značku sa zobrazí bublina. Odporúča sa pre minimálne množstvo obsahu',
    MINI_DESC: 'Kliknutím na interaktívnu značku sa zobrazí vyskakovacie okno. Odporúča sa pre malé množstvo obsahu',
    STYLE1_DESC: 'Kliknutím na interaktívnu značku sa zobrazí bočný panel. Odporúča sa pre akékoľvek množstvo obsahu',
    PANEL: 'Panel',
    POPUP: 'Okno',
    BUBBLE: 'Bublina',
    PUBLIC: 'Verejné',
    PRIVATE: 'Súkromné',
    MAP_STYLE: 'Štýl mapy',
    FILL_COUNTRIES: 'Vyplniť krajiny',
    REGISTER_PROMPT: 'Zaregistrujte sa, aby ste mohli svoju mapu uložiť',
    GET_MORE_PROMPT: 'Získajte viac návštev a neobmedzené množstvo značiek prechodom na režim Pro',
    CONTACT_PROMPT: 'Chcete prístup k pokročilému editoru alebo potrebujete ešte viac návštev?',
    UNLOCK_PROMPT: 'Odomknite všetky funkcie a zvýšte návštevnosť mapy v režime Creator alebo Pro',
    UPGRADE: 'Vylepšiť',
    MAP_VISITS_LIMIT: 'Obmedzenie návštev mapy',
    MARKER_LIMIT: 'Obmedzenie značiek',
    ADVANCED_EDITOR_ACCESS: 'Prístup k pokročilému editoru',
    REGISTER_ACTION: 'Registrovať sa',
    NO: 'Nie',
    YES: 'Áno',
    SYMBOL: 'Symbol',
    YOUR_IMAGE: 'Váš obrázok',
    SEARCH: 'Hľadať',
    SEARCH_ON_MAP: 'Hľadať na mape',
    MORE: 'Viac',
    BACKGROUND: 'Pozadie',
    CONTROLS: 'Ovládanie',
    CLONE: 'Klonovať',
    ORDER: 'Poradie',
    TOP: 'Hore',
    BOTTOM: 'Dole',
    EMOJI: 'Emoji',
    SEARCH_GIFS: 'Hľadať GIFy',
    DELETE: 'Vymazať',
    TRANSPORTATION: 'Doprava',
    COORDINATES: 'Súradnice',
    POINT_X: 'Bod {0}',
    POSITION: 'Pozícia',
    GROUND_COLOR: 'Podlaha',
    STYLE: 'Štýl',
    COLOR: 'Farba',
    SIZE: 'Veľkosť',
    POSITION_DESC: 'Kliknite kdekoľvek na mape pre zmenu pozície',
    TRANSFORM: 'Transformovať',
    ROTATE: 'Otočiť',
    SCALE: 'Mierka',
    BORDER_SIZE: 'Veľkosť okraja',
    OPACITY: 'Priehľadnosť',
    BORDER_COLOR: 'Farba okraja',
    DASHED: 'Čiarkované',
    HEIGHT: 'Výška',
    BASE_HEIGHT: 'Výška základne',
    WIDTH: 'Šírka',
    DIRECTION_ADD1: 'Kliknite kdekoľvek na mape pre nastavenie počiatočného bodu alebo vyhľadajte adresu',
    DIRECTION_ADD2: 'Kliknite znovu pre nastavenie cieľa alebo vyhľadajte adresu (alebo Esc pre zrušenie)',
    ICON_ADD: 'Kliknite kdekoľvek na mape alebo vyhľadajte adresu pre pridanie značky. Značka si vždy udržiava rovnakú veľkosť',
    VARIANT_ICON_ADD: 'Kliknite kdekoľvek na mape alebo vyhľadajte adresu pre pridanie značky. Značka si udržiava rovnakú veľkosť, ale jej štýl sa mení na základe úrovne priblíženia',
    IMAGE_ADD: 'Kliknite kdekoľvek na mape pre nahranie obrázku alebo pretiahnite jeden zo symbolov alebo obrázkov z galérie',
    TEXT_ADD: 'Kliknite kdekoľvek na mape pre pridanie textu',
    LINE_ADD: 'Začnite klikať na mape pre nakreslenie čiary. Stlačte Enter pre dokončenie (alebo Esc pre zrušenie)',
    POLYGON_ADD: 'Začnite klikať na mape pre nakreslenie polygónu. Stlačte Enter pre dokončenie (alebo Esc pre zrušenie)',
    WALL_ADD: 'Začnite klikať na mape pre nakreslenie 3D steny. Stlačte Enter pre dokončenie (alebo Esc pre zrušenie)',
    ADDRESS_SEARCH: 'Vyhľadávanie adresy',
    STARTING_POINT: 'Počiatočný bod',
    DESTINATION: 'Cieľ',
    GALLERY: 'Galéria',
    POLYGON_ADD2: 'Polygóny možno urobiť neviditeľné a stále spúšťať akcie po kliknutí (Výhodné najmä pre mapy obrázkov)',
    ZOOM_IN_MORE: 'Priblížte sa viac pre nakreslenie steny',
    LABEL: 'Štítok',
    ICON: 'Ikona',
    INTERACTIVITY_PROMPT: 'Definujte, čo ľudia uvidia, keď kliknú na značku',
    CREATE_INTERACTIVITY_ACTION: 'Vytvoriť interaktivitu',
    CONFIRM_SAVE: 'Chcete uložiť zmeny?',
    CONFIRM_REMOVE_INTERACTIVITY: 'Chcete odstrániť túto interaktivitu?',
    SAVING: 'Ukladá sa',
    REFRESH_PREVIEW: 'Obnoviť náhľad',
    SHOW_PREVIEW: 'Zobraziť náhľad',
    REMOVE_INTERACTIVITY: 'Odstrániť interaktivitu',
    MAX_LENGTH_TEXT_MARKER: 'Dosiahli ste maximálnu dĺžku textu 1000 znakov',
    MAP_ROTATION: 'Rotácia mapy',
    PITCH_ANGLE: 'Uhol náklonu (zobrazenie iba)',
    GPX_FILE: 'GPX súbor',
    GPX_UPLOAD_MESSAGE: 'Nahrajte svoj súbor GPX vpravo. Ak súbor nie je podporovaný, napíšte nám správu',
    EXPERIMENTAL_FEATURES_MESSAGE: 'Môžete aktivovať experimentálne funkcie. Toto je určené iba pre skúsených tvorcov a testerov',
    EXPERIMENTAL: 'Experimentálne',
    LATITUDE: 'Šírka',
    LONGITUDE: 'Dĺžka',
    FILE_UPLOAD: 'Nahratie súboru',
    UNKNOWN_GPX_FILE: 'Neznámy formát súboru GPX',
    OPEN_GALLERY: 'Otvoriť galériu',
    GALLERY_ALL: 'Všetko',
    GALLERY_YOUR_IMAGES: 'Vaše obrázky',
    GALLERY_CATEGORY_IMAGES: 'Obrázky kategórie',
    GALLERY_NATURE: 'Príroda',
    GALLERY_ANIMALS: 'Zvieratá',
    GALLERY_VEHICLES: 'Vozidlá',
    GALLERY_BUILDINGS: 'Budovy',
    GALLERY_FLAGS: 'Vlajky',
    USE_COMPUTER: 'Na tvorbu máp použite počítač',
    USE_COMPUTER_DESC: 'Editor máp nie je optimalizovaný pre mobilné zariadenia, použite prosím väčší displej. Nemajte strach, všetky mapy vytvorené prostredníctvom editora skvele fungujú na mobilných zariadeniach.',
    CONTINUE_ANYWAY: 'Pokračovať napriek tomu',
    GO_TO_HOMEPAGE: 'Ísť na domovskú stránku',
    DELETE_MAP: 'Vymazať mapu',
    ADD_FLOOR: 'Pridať podlažie',
    FLOORS: 'Poschodia',
    FLOOR_NR: 'Poschodie č.',
    ADD_CATEGORY: 'Pridať kategóriu',
    CATEGORIES: 'Kategórie',
    CATEGORY_NR: 'Kategória č.',
    VISIBLE_ON_LOAD: 'Viditeľné pri načítaní',
    DELETE_MAP_CONFIRM: 'Naozaj chcete vymazať túto mapu?',
    DELETE_FLOOR_CONFIRM: 'Naozaj chcete vymazať toto podlažie?',
    DELETE_CATEGORY_CONFIRM: 'Naozaj chcete vymazať túto kategóriu?',
    STAND: 'Stánok',
    CLICK_ANYWHERE_TO_STAND: 'Kliknite kdekoľvek pre pridanie stánku',
    MAP_DELETED: 'Mapa vymazaná',
    PIN_IMAGE: 'Obrázok značky',
    LOGO_IMAGE: 'Obrázok loga',
    FILLING: 'Výplň',
    FILLING1: 'Táto možnosť zobrazuje iba 3D stenu. Posledný bod nemusí byť pripojený k prvým',
    FILLING2: 'Táto možnosť zobrazuje 3D stenu a podlahu. Automaticky uzatvára oblasť',
    FILLING3: 'Táto možnosť vytvára 3D štruktúru. Automaticky uzatvára oblasť',
    BOOKING: 'Rezervácia',
    DELETE_BOOKING: 'Vymazať rezerváciu',
    DELETE_BOOKING_CONFIRM: 'Ste si istý, že chcete vymazať túto rezerváciu? Túto akciu nie je možné vrátiť späť.',
    BOOKING_FIELD_TYPE_CHECKBOX: 'Áno/Nie',
    BOOKING_FIELD_TYPE_TEXT: 'Text',
    BOOKING_FIELD_TYPE_EMAIL: 'Email',
    BOOKING_EMPTY_INFO: 'Zatiaľ neexistuje žiadna rezervácia. Nižšie môžete vidieť polia, ktoré sa zbierajú.',
    FIELD_REQUIRED: 'Toto pole je povinné',
    BOOKING_SUBMIT: 'Vytvoriť rezerváciu',
    BOOKING_SUCCESS_TITLE: 'Vaša rezervácia je potvrdená',
    BOOKING_SUCCESS_MESSAGE: 'Ďakujeme za vašu rezerváciu. Na váš e-mail dorazí potvrdzovací e-mail. Ak e-mail v doručenej pošte nevidíte,',
    BOOKING_SUCCESS_MESSAGE_CHECK_SPAM: 'skontrolujte prosím priečinok spam.',
    BOOKING_FAILED_TITLE: 'Vaša rezervácia sa nepodarilo vytvoriť',
    BOOKING_FAILED_MESSAGE: 'Vyzerá to, že tento stánok pred vami niekto zarezervoval. Obnovte prosím stránku a vyberte zo zoznamu stánok, ktorý je v súčasnej dobe k dispozícii. Voľné stánky sú označené zeleno.',
    BOOKING_FULL_TITLE: 'Tento stánok je už zarezervovaný',
    BOOKING_FULL_MESSAGE: 'Vyberte prosím zo zoznamu stánok, ktorý je v súčasnej dobe k dispozícii. Voľné stánky sú označené zeleno.',
    BOOKING_CLOSE_DIALOG: 'Zavrieť dialóg',
    BOOKING_SEE_OTHER_STANDS: 'Zobraziť mapu',
    OR: 'alebo',
    SEARCH_DETAIL_PLACEHOLDER: 'Vyhľadať existujúcu interaktivitu',
    REFRESH_PAGE: 'Obnoviť stránku',
    EXTERNAL_LINK: 'Externý odkaz',
    STAND_MARKER1: 'Ikona (Priblížené)',
    STAND_MARKER2: 'Ikona (Oddialené)',
    LOAD_FROM_DETAIL: 'Načítať z detailu',
    DISPLAY_IN_RECTANGLE: 'Zobraziť v obdĺžniku',
    COLORED_PIN: 'Farebná značka',
    CUSTOM_IMAGE: 'Vlastný obrázok',
    USE_IN_GUIDE: 'Použiť v sprievodcovi',
    LOCATION_NAME: 'Názov miesta',
    DETAILS: 'Detaily',
    PREVIEW: 'Náhľad',
    UNSAVED_CHANGES: 'Neuložené zmeny',
    NO_TITLE: 'Bez názvu',
    SHOW_ON_ZOOM: 'Priblíženie (Zobraziť na mape)',
    NO_EDIT_IN_MAP_EDITOR: 'Tento obsah nie je možné upraviť v Map Editori.',
    GLOBAL_POINTS_EDIT_NOT_SUPPORTED: 'Globálne body nie je možné upraviť. Upravte tento bod priamo vo svojom CMS systéme',
    NEWSFEED: 'Novinky',
    EDIT_NEWSFEED_MESSAGE: 'Upraviť správu v novinkách',
    PC_WELCOME_MESSAGE: 'PC Vítacia správa',
    TEST_NEWSFEED_NOTIFICATION: 'Testovacie oznámenie v novinkách',
    NEWSFEED_SELECT_USERS: 'Vyberte používateľov',
    NEWSFEED_SEND_TEST_NOTIFICATION: 'Odoslať testovacie oznámenie',
    HEADER_IMAGE: 'Obrázok hlavičky',
    NAVIGATION_TITLE: 'Navigácia',
    NAVIGATION_DESCRIPTION: 'Definujte, ako sa používateľ pohybuje vo vašej aplikácii',
    NAVIGATION_LINK_DESTINATION: 'Cieľ odkazu',
    NAVIGATION_EXTERNL_URL: 'Externá URL',
    NAVIGATION_SELECT_LIST: 'Vyberte zoznam',
    NAVIGATION_SELECT_FORM: 'Vyberte formulár',
    NAVIGATION_SHOW_DYNAMIC_NUMBER: 'Zobraziť dynamické číslo',
    NAVIGATION_CUSTOM_ICON: 'Vlastná ikona',
    NAVIGATION_CUSTOM_TITLE: 'Vlastný názov',
    NAVIGATION_DRAWER_HELP: 'Zásuvka je rozdelená na primárne (veľké) a sekundárne (malé) tlačidlá. Môžete nastaviť, koľko tlačidiel je primárnych',
    NEWSFEED_CREATE_NEW_MESSAGE: 'Vytvoriť novú správu',
    NEWSFEED_HELP: 'Aktualizácie, ktoré môžete zdieľať so svojimi návštevníkmi. Správy sú viditeľné v sekcii Novinky a používatelia sú o nich informovaní prostredníctvom Push notifikácií',
    NEWSFEED_REMOVE_CONFIRM: 'Ste si istý, že chcete odstrániť správu v novinkách?',
    NEWSFEED_SEND_TO_ALL_CONFIRM: 'Ste si istý, že chcete odoslať oznámenie všetkým používateľom aplikácie?',
    NEWSFEED_NOTIFICATIONS: 'Oznámenia',
    NEWSFEED_NOTIFICATIONS_SENT: 'Oznámenia odoslané',
    ROOMS: 'Miestnosti',
    VARIANT_ICON: 'Variant ikona',
    LIST_VIEW_TYPE: 'Typ zobrazenia zoznamu',
    CREATE_FORM: 'Vytvoriť formulár',
    EDIT_FORM: 'Upraviť formulár',
    FORM_TITLE: 'Názov formulára',
    FORM_THANK_YOU_MESSAGE: 'Ďakujem správa',
    FORM_ALLOW_MULTIPLE_SUBMISSIONS: 'Povoliť viacero odoslaní',
    FORM: 'Formulár',
    FORM_FIELDS: 'Polia',
    FORM_FIELD_TITLE: 'Názov poľa',
    FORM_FIELD_TEXT: 'Textové pole',
    FORM_OPTIONS: 'Možnosti',
    REQUIRED: 'Povinné',
    EXTERNAL_POINTS: 'Externé body',
    EXTERNAL_POINTS_DESCRIPTION: 'Pridať externé body z vášho CMS',
    ENABLE_HIGHLIGHTED_CATEGORY: 'Povoliť zvýraznenú kategóriu',
    TOP_LEFT: 'Vľavo dole',
    BOTTOM_RIGHT: 'Vpravo dole',
    INITIAL_POSITION: 'Počiatočná pozícia',
    ZOOM_SETTINGS: 'undefined',
    VISIBLE_IN: 'Viditeľné v',
    MAP_ORIENTATION: 'Orientácia mapy',
    MIN_MAX_ZOOM: 'Min/Max zoom',
    CURRENT_VIEW_INFO: 'Informácie o aktuálnom zobrazení',
    CURRENT_ZOOM: 'Aktuálny zoom',
    LAST_CLICK: 'Posledné kliknutie',
    GLOBAL_MARKER_SETTINGS: 'Globálne nastavenia značky',
    PIN_SETTINGS: 'Nastavenia značky',
    TEXT_COLOR: 'Farba textu',
    BACKGROUND_COLOR: 'Farba pozadia',
    AUTO_HIDE_LABELS: 'Automaticky skryť popisky',
    MARKER_GROUPING: 'Zoskupovanie značiek',
    MAX_CLUSTERING_ZOOM: 'Maximálne zoskupovanie zväčšenie',
    CLUSTER_RADIUS: 'Polomer zoskupenia',
    SHOW_LIST_OF_DETAILS: 'Zobraziť zoznam detailov',
    NO_LIST: 'Bez zoznamu',
    SHOW_LIST: 'Zobraziť zoznam',
    SHOW_LIST_WITH_SEARCH: 'Zobraziť zoznam s vyhľadávaním',
    HOME: 'Domov',
    MAP: 'Mapa',
    PROGRAMME_SHORT: 'Program',
    SPEAKERS: 'Rečníci',
    INFO: 'Info',
    MAP_VIEW: 'Zobrazenie mapy',
    REMOVE_FILTERS: 'Odstrániť filtre',
    LIST_VIEW: 'Zobrazenie zoznamu',
    GUIDANCE: 'Sprievodca',
    HIGHLIGHTED: 'Zvýraznené',
    EXHIBITORS: 'Vystavovatelia',
    SURVEY: 'Dotazník',
    OPEN_ON_YOUR_PHONE: 'Otvoriť na telefóne',
    INTERACTIVE_MAP: 'Interaktívna mapa',
    SHOW_MORE: 'Zobraziť viac',
    LINKS: 'Odkazy',
    FORM_SUBMIT: 'Odoslať formulár',
    FORM_SUBMITTED: 'Formulár bol úspešne odoslaný',
    INVALID_VALUE: 'Neplatná hodnota',
    COMPANIES: 'Firmy',
    LIST: 'Zoznam',
    FILTERS: 'Filtry',
    ZOOM: 'Zoom',
    HIGHLIGHT: 'Zvýrazniť',
    UNHIGHLIGHT: 'Zrušiť',
    WEBSITE: 'Stránka',
    PREVIOUS: 'Predchádzajúci',
    NEXT: 'Ďalší',
    SHOW_ON_MAP: 'Zobraziť na mape',
    CLOSE: 'Zavrieť',
    SHOW_ALL: 'Zobraziť všetko',
    HIDE_ALL: 'Skryť všetko',
    PROGRAMME: 'Program',
    PLACES: 'Miesta',
    THIS_IS_INTERACTIVE_MAP: 'Toto je interaktívna mapa',
    CLICK_ON_INFO: 'Kliknite na značky pre viac informácií',
    CONTINUE: 'Pokračovať',
    MAPBOX_SCROLL_ZOOM_BLOCKER_CTRL: 'Použite ctrl + scroll pre zoom mapy',
    MAPBOX_SCROLL_ZOOM_BLOCKER_COMMAND: 'Použite ⌘ + scroll pre zoom mapy',
    SUBMIT_AGAIN: 'Odoslať znova',
    OTHER_ITEMS: 'Iné',
    MAIN_H1: 'Vytvorte interaktívnu mapu za minútu',
    MAIN_H2: 'Zdieľajte, Embedujte, Predávajte. Ako len chcete. Bez registrácie',
    YOUR_POSSIBILITIES: 'Vaše možnosti',
    GET_YOUR_INSPIRATION: 'Získajte inšpiráciu',
    NAME_YOUR_MAP: 'Pomenovanie mapy',
    AGREE_WITH: 'Súhlasím s',
    TERMS_AND_CONDITIONS: 'podmienkami',
    CREATE_YOUR_MAP: 'Vytvorte si mapu',
    HERO_BLOCK1_H1: 'Vyberte si štýl',
    HERO_BLOCK1_P1: 'Vyberte si štýl mapy, ktorý sa vám páči. Na výber je veľa rôznych štýlov, ktoré vyhovujú vašim potrebám a zodpovedajú vašej značke. Môžete dokonca nahrať vlastnú mapu ako obrázok a pridať na ňu interaktívne značky',
    HERO_BLOCK2_H1: 'Pridajte ľubovoľné značky',
    HERO_BLOCK2_P1: 'Ukážte svoju kreatívnu stránku. Do mapy môžete pridať značky, ako sú špendlíky, obrázky, tvary, cesty a čiary. K dispozícii je aj pripravená knižnica obrázkov a ikon generovaných umelou inteligenciou, z ktorej si môžete vybrať',
    HERO_BLOCK3_H1: 'Urobte to interaktívne',
    HERO_BLOCK3_P1: 'Každá značka, ktorú umiestnite na mapu, môže byť interaktívna. Keď na ňu návštevníci kliknú, môžu vidieť váš text, obrázky, odkazy, videá a ďalšie informácie. Týmto spôsobom im môžete ľahko poskytnúť dodatočnú hodnotu',
    TRAVELLING: 'Cestovanie',
    CABIN_MAP: 'Mapa chat',
    CITY_MAP: 'Mestská mapa',
    FOOD_FESTIVAL: 'Festival jedla',
    FESTIVALS: 'Festivaly',
    MUSIC_FESTIVAL: 'Hudobný festival',
    FAIRS: 'Trhy',
    JOB_FAIR: 'Veľtrh práce',
    THEME_PARKS: 'Zábavné parky',
    FAMILY_PARK: 'Rodinný park',
    CONFERENCES: 'Konferencie',
    CONFERENCE: 'Konferencia',
    BUSINESS: 'Podnikanie',
    CUSTOMER_MAP: 'Mapa zákazníkov',
    SPORT: 'Šport',
    RUNNING_RACE: 'Behový beh',
    TRONDHEIM_NORWAY: 'Trondheim, Nórsko',
    GOTA_FAROE_ISLANDS: 'Gota, Faerské ostrovy',
    TYDAL_NORWAY: 'Tydal, Nórsko',
    LIBEREC_CZECHIA: 'Liberec, Česko',
    AGDER_NORWAY: 'Agder, Nórsko',
    AARHUS_DENMARK: 'Aarhus, Dánsko',
    NAMSSKOGAN_NORWAY: 'Namsskogan, Nórsko',
    HEMSEDAL_NORWAY: 'Hemsedal, Nórsko',
    BRNO_CZECHIA: 'Brno, Česko',
    CHOOSE_YOUR_STYLE: 'Vyberte si štýl',
    CLASSIC: 'Klasický',
    SATELLITE: 'Satelitný',
    OUTDOORS: 'Vonkajší',
    DARK: 'Tmavý',
    LIGHT: 'Svetlý',
    COLORED: 'Farebný',
    IMAGE_MAP: 'Obrázková mapa',
    UPLOADING: 'Nahrávanie',
    BACK: 'Späť',
    I_LIKE_THIS_ONE: 'Tento sa mi páči',
    CONGRAT_TITLE: 'Gratulujeme, vaša mapa je vytvorená!',
    CONGRAT_DESC: 'Teraz pridajte nejaké značky, aby ste ukázali svoje miesta',
    MARKER_SELECTION: 'Výber značky',
    MARKER_SELECTION_DESC: 'Vyberte značky zospodu',
    STYLING: 'Úpravy',
    STYLING_DESC: 'Nastylujte značky vpravo',
    START_ACTION: 'Začnite pridávať značky',
    CREATING_PROMPT1: 'Ahoj!',
    CREATING_PROMPT1_DESC: 'Vytvárate skvelú mapu! Neztráťte ju, keď odíďete. Vytvorte si teraz účet zdarma',
    CREATING_PROMPT2: 'Chcete viac funkcií?',
    CREATING_PROMPT2_DESC: 'Pridajte sa na našu čakaciu listinu a buďte medzi prvými, ktorí získajú viac funkcií!',
    JOIN_ACTION: 'Pripojiť sa',
    ALREADY_CREATING: 'Už vytvárate mapu',
    CONTINUE_CREATING: 'Pokračovať v tvorbe',
    ALL: 'Všetko',
    EAT: 'Jedlo',
    EXPLORE: 'Preskúmať',
    EXPERIENCE: 'Skúsiť',
    LEARN: 'Učiť',
    LANDING_TITLE: 'undefined',
    LANDING_DESCRIPTION: 'undefined',
    LANDING_ITEM1: 'undefined',
    LANDING_ITEM2: 'undefined',
    LANDING_ITEM3: 'undefined',
    GUIDES: 'undefined',
    GUIDES_DESC: 'undefined',
    EDIT_GUIDE_NO_LOGIN: 'undefined',
    CREATE_GUIDE_NO_LOGIN: 'undefined',
    NEW_GUIDE_TITLE: 'undefined',
    NEW_MAP_TITLE: 'undefined',
    NEW_GUIDE_MESSAGE: 'undefined',
    INTERACTIVE_MAPS: 'undefined',
    INTERACTIVE_MAPS_DESC: 'undefined',
    EDIT_MAP_NO_LOGIN: 'undefined',
    CREATE_MAP_NO_LOGIN: 'undefined',
    CREATE_GUIDE: 'undefined',
    GUIDE_NAME: 'undefined',
    ACTIONS: 'undefined',
    MAP_NAME: 'undefined',
    EDIT_MAP: 'undefined',
    EDIT_DETAILS: 'undefined',
    CREATE_MAP: 'undefined',
    CONFIGURATION: 'undefined',
    LISTS: 'undefined',
    PROGRAM: 'Program',
    SHARE: 'undefined',
    CONFIGURATION_TITLE: 'undefined',
    CONFIGURATION_DESC: 'undefined',
    CONFIGURATION_ITEM1: 'undefined',
    CONFIGURATION_ITEM2: 'undefined',
    CONFIGURATION_ITEM3: 'undefined',
    CONFIGURATION_ITEM4: 'undefined',
    BASIC_INFORMATION: 'undefined',
    BASIC_INFORMATION_DESC: 'undefined',
    FEATURES: 'undefined',
    FEATURES_DESC: 'undefined',
    OTHER_INFORMATION: 'undefined',
    EXTERNAL_LINKS: 'undefined',
    EXTERNAL_LINKS_DESC: 'undefined',
    CUSTOM_FEATURES: 'undefined',
    CUSTOM_FEATURES_DESC: 'undefined',
    CUSTOM_FEATURES_ITEM1: 'undefined',
    CUSTOM_FEATURES_ITEM2: 'undefined',
    CUSTOM_FEATURES_ITEM3: 'undefined',
    INFORMATION: 'undefined',
    WELCOME_MESSAGE: 'undefined',
    COLOR_THEME: 'undefined',
    LOGO: 'undefined',
    LISTS_DESC2: 'undefined',
    PROGRAM_DESC: 'undefined',
    INFO_DESC: 'undefined',
    MAP_DESC: 'undefined',
    OPEN_ACTION: 'undefined',
    START_DATE: 'undefined',
    END_DATE: 'undefined',
    MAP_PREVIEW: 'undefined',
    DATES: 'undefined',
    VISUAL: 'undefined',
    ASK_REMOVE_LINK: 'undefined',
    URL: 'undefined',
    MESSAGE: 'undefined',
    SEND_EMAIL: 'undefined',
    EMAIL_SENT1: 'undefined',
    EMAIL_SENT2: 'undefined',
    EMAIL_SENT1_DESC: 'undefined',
    EMAIL_SENT2_DESC: 'undefined',
    CLONE_GUIDE: 'undefined',
    CLONING: 'undefined',
    CLONE_MESSAGE: 'undefined',
    DELETE_GUIDE: 'undefined',
    DELETING: 'undefined',
    DELETE_MESSAGE: 'undefined',
    CANCEL: 'undefined',
    CONFIRM: 'undefined',
    NEW_DETAIL: 'undefined',
    DETAIL_CREATED: 'undefined',
    CATEGORY_CREATED: 'undefined',
    DONE: 'undefined',
    DETAILS_TITLE: 'undefined',
    DETAILS_DESC: 'undefined',
    DETAILS_ITEM1: 'undefined',
    DETAILS_ITEM2: 'undefined',
    DETAILS_DESC2: 'undefined',
    CREATING: 'undefined',
    CREATE_DETAIL: 'undefined',
    NOT_USED: 'undefined',
    FILTER: 'undefined',
    CREATE_CATEGORY: 'undefined',
    CATEGORIES_DESC: 'undefined',
    ASK_DELETE_DETAIL: 'undefined',
    USAGE: 'undefined',
    ASK_DELETE_CATEGORY: 'undefined',
    QUICK_ASSIGN_LISTS: 'undefined',
    EDIT_CATEGORIES: 'undefined',
    NO_CATEGORIES: 'undefined',
    GO_TO_DETAILS: 'undefined',
    EDIT_CATEGORY: 'undefined',
    BACK_TO_DETAILS: 'undefined',
    EDIT_DETAIL: 'undefined',
    EDIT_DETAIL_DESC: 'undefined',
    EDIT_DETAIL_ITEM1: 'undefined',
    EDIT_DETAIL_ITEM2: 'undefined',
    EDIT_DETAIL_ITEM3: 'undefined',
    EDIT_DETAIL_ITEM4: 'undefined',
    HEADER_DETAIL: 'undefined',
    HEADER_DETAIL_DESC: 'undefined',
    CONTENT_DETAIL: 'undefined',
    CONTENT_DETAIL_DESC: 'undefined',
    LIVE_PREVIEW: 'undefined',
    STRETCH_IMAGE: 'undefined',
    GIF_CARD: 'undefined',
    ASK_DELETE_IMAGE: 'undefined',
    IMAGE_CARD: 'undefined',
    LINK_CARD: 'undefined',
    LINKED_STORIES_CARD: 'undefined',
    TEXT_CARD: 'undefined',
    ASK_DELETE_CARD: 'undefined',
    OPEN_YOUTUBE: 'Otvoriť YouTube',
    OPEN_FACEBOOK: 'Otvoriť Facebook',
    OPEN_TWITTER: 'Otvoriť Twitter',
    OPEN_INSTAGRAM: 'Otvoriť Instagram',
    CREATE_LISTS_TITLE: 'undefined',
    CREATE_LISTS_DESC: 'undefined',
    CREATE_LISTS_ITEM1: 'undefined',
    CREATE_LISTS_ITEM2: 'undefined',
    CREATE_LISTS_ITEM3: 'undefined',
    LISTS_DESC: 'undefined',
    CREATE_LIST: 'undefined',
    THIS_PREVIEW: 'undefined',
    THIS_PREVIEW_DESC: 'undefined',
    OPEN_IN_TAB: 'undefined',
    ASK_DELETE_LIST: 'undefined',
    LINKED_DETAILS: 'undefined',
    LINK_DETAILS: 'undefined',
    NO_DETAILS: 'undefined',
    SEARCH_DETAILS: 'undefined',
    NO_OPTIONS: 'undefined',
    EDIT_LIST: 'undefined',
    LINK_TEXT: 'undefined',
    LINK_URL: 'undefined',
    LINK_TO_MAP: 'undefined',
    SEARCHABLE: 'undefined',
    MODIFY_PROGRAM: 'undefined',
    MODIFY_PROGRAM_DESC: 'undefined',
    MODIFY_PROGRAM_ITEM1: 'undefined',
    MODIFY_PROGRAM_ITEM2: 'undefined',
    MODIFY_PROGRAM_ITEM3: 'undefined',
    EVENTS: 'undefined',
    EVENTS_DESC: 'undefined',
    CREATE_EVENT: 'undefined',
    ASK_REMOVE_EVENT: 'undefined',
    IN_MAP: 'undefined',
    DATE: 'undefined',
    EDIT_EVENT: 'undefined',
    AUTOFILL_INFO: 'undefined',
    TIME_START: 'undefined',
    TIME_END: 'undefined',
    MAP_LOCATION: 'undefined',
    SELECT_MARKER: 'undefined',
    NO_MAP_LOCATIONS: 'undefined',
    GO_TO_MAP: 'undefined',
    MODIFY_INFORMATION: 'undefined',
    MODIFY_INFORMATION_DESC: 'undefined',
    MODIFY_INFORMATION_ITEM1: 'undefined',
    INFORMATION_DESC: 'undefined',
    CREATE_MAP_TITLE: 'undefined',
    CREATE_MAP_DESC: 'undefined',
    CREATE_MAP_ITEM1: 'undefined',
    INTERACTIVE_MAP_DESC: 'undefined',
    OPEN_EDITOR: 'undefined',
    SHARE_APPLICATION: 'undefined',
    SHARE_APPLICATION_DESC: 'undefined',
    SHARE_APPLICATION_ITEM1: 'undefined',
    SHARE_APPLICATION_ITEM2: 'undefined',
    SHARE_THE_APPLICATION: 'undefined',
    SHARE_THE_APPLICATION_DESC: 'undefined',
    COPY_LINK: 'undefined',
    COPY: 'undefined',
    OPEN_LINK: 'undefined',
    DOWNLOAD_QR: 'undefined',
    QR_CODE: 'undefined',
    EMBEDDED_MAP_IFRAME: 'undefined',
    FORMS: 'undefined',
    FORM_SUBMISSIONS: 'undefined',
    FORMS_DESC: 'undefined',
    MAP_V2_SEARCH_THIS_MAP: 'Hľadať na mape',
    MAP_V2_COLLAPSE: 'Zbaliť',
    MAP_V2_EXPAND: 'Rozbaliť',
    MAP_V2_GO_BACK: 'Ísť späť',
    MAP_V2_GOOGLE_MAPS_NAVIGATION: 'Navigácia Google Maps',
    MAP_V2_ALL_PLACES: 'Všetky miesta',
    MAP_V2_SELECTED_GROUP: 'Vybraná skupina',
    MAP_V2_CATEGORY_SHOW_ALL: 'Zobraziť všetko',
    MAP_V2_CATEGORY_HIGHLIGHTS: 'Zvýraznené',
    MAP_V2_CATEGORY_HERITAGE: 'Dedičstvo',
    MAP_V2_CATEGORY_DINING: 'Stravovanie',
    MAP_V2_CATEGORY_FUN: 'Zábava',
    MAP_V2_CATEGORY_ART: 'Umenie',
    MAP_V2_CATEGORY_EVENTS: 'Udalosti',
    MAP_V2_PLACES_POSTFIX: 'miest',
    MAP_V2_FULLSCREEN_TURN_OFF: 'Ukončiť celú obrazovku',
    MAP_V2_FULLSCREEN_TURN_ON: 'Prepnúť mapu do celého displeja'
};
